import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { axiosGetWithHeader, axiosPostWithHeader } from '../Common/axios';

export function AppHeader({errorObject}) {
  const [search, setSearch] = useState([]);
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(null);
  const [showSearchAlert, setShowSearchAlert] = useState(false);
  const [searchErrorMessage, setSearchErrorMessage] = useState(null);
  const navigate = useNavigate();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleSearchClose = () => setShowSearchAlert(false);
  const handleSearchShow = () => setShowSearchAlert(true);

  const handleLogout=() =>{
    setShow(false);
    localStorage.removeItem("token");
    setTimeout(() => {
      navigate('/', { replace: true });
    }, 100);
  }

  const handleHome=() =>{
    handleModelError(false,null);
    setShow(false);
    setTimeout(() => {
      navigate('/home.html', { replace: true });
    }, 100);
  }

  const handleModelError = (show, msg) => {
    setShowError(show);
    if(show) {
      setShowErrorMessage(msg);
    } else {
      setShowErrorMessage(null);
    }
  }

  var callCommand=(event)=>{
    var keyValue = event.target.value;
    setSearch(keyValue);
    if(keyValue.length<2) {
      setData([]);
    } else {
      const requestdata = {
        pageNumber: 0,
        pageSize: 5,
        keyword : keyValue.trim(),
      }
      axiosPostWithHeader("/users/search", requestdata, 
        (response)=>{
          setData(response.data);
        },
        (error)=>{
          //alert(error.message);
          setData([]);
          handleModelError(true,error.message);
        }
      );

    }
  }

  var onSearch=()=> {
    var keyValue = search;
    if(keyValue===null||keyValue.length===0) {
      setSearchErrorMessage("Enter search keyword like Id, Name, DOB, Mobile, Email, Birth Place");
      handleSearchShow();
      return false;
    }
    var ind1 = keyValue.indexOf(" - ");
    var id = (ind1===-1)?'':keyValue.substring(0,ind1);

    if(id!==null&&id!==''&&id!==undefined&& id.length>0) {
      axiosGetWithHeader("/user/"+id, 
        (response)=>{
          if(response.data===null||response.data===''||response.data===undefined){
            setData([]);
            setSearchErrorMessage("Client is not found with the search keyword");
            handleSearchShow();
            return; 
          }
          axiosGetWithHeader("/users/history/"+id, 
            (response)=>{
              console.log(response.message);
            },
            (error)=>{
              console.log(error);
            }
          );
          setTimeout(() => {
            navigate('/kpastro.html', { state:{runningId:id}, replace: true });
            navigate(0);
          }, 100);
        },
        (error)=>{
          setData([]);
          setSearchErrorMessage("Client is not found with the search keyword");
          handleSearchShow();
        }
      );
    } else {
      keyValue = search;
      setSearch(keyValue);
      const requestdata = {
        pageNumber: 0,
        pageSize: 5,
        keyword : keyValue.trim(),
      }
      axiosPostWithHeader("/users/search", requestdata, 
        (response)=>{
          if(response.data===null||response.data.length===0) {
            setSearchErrorMessage("Client is not found with the search keyword.");
            handleSearchShow();
          } else if(response.data.length===1) {
            setTimeout(() => {
              navigate('/kpastro.html', { state:{runningId:response.data[0].runningId}, replace: true });
              navigate(0);
            }, 100);
          } else {
            setData(response.data);
            setSearchErrorMessage("Multiple Client details found. Search with specific keyword");
            handleSearchShow();
          }
        },
        (error)=>{
          //alert(error.message);
          setData([]);
          handleModelError(true,error.message);
        }
      );
    }

  }

  return (
    <>
      <div class="d-md-none row m-0 p-0">
        <nav class="navbar navbar-expand-sm p-0">
          <div class="ps-2">
            <a class="navbar-brand p-0" href="/home.html">
              <img src="/images/logo.png" alt="Yawin Astro"  class="p-0 logostyle" />
              <span class="ps-2 logotitlestyle">Yawin</span>
            </a>   
          </div>
          <div class="pe-2">
            <Link to="/home.html">
              <img src="/images/home_trans.png" data-bs-toggle="tooltip" data-bs-placement="top" title="Home" alt="Home"  class="p-0 headericonstyle"/>
            </Link>
            <Link to="/caconfig.html">
              <img src="/images/settings_trans.png" data-bs-toggle="tooltip" data-bs-placement="top" title="Settings" alt="Settings"  class="p-0 headericonstyle"/>
            </Link>
            <Link to="/profile.html">
              <img src="/images/profile_trans.png" data-bs-toggle="tooltip" data-bs-placement="top" title="Profile" alt="Profile"  class="p-0 headericonstyle" />
            </Link>
            <button class="navbar-brand p-0 btn btn-white border-0">
              <img src="/images/logout_trans.png" onClick={handleShow} title="Logout" alt="Logout" class="p-0 headericonstyle"/>
            </button>
          </div>
        </nav>
        
        <div class="input-group ">
        <input type="input" class="form-control" list="usrlist" id="search" placeholder="Search by Id, Name, DOB(yyyy-mm-dd), Mobile, Email, Birth Place" title="Type few characters of Id, Name, Date of Birth(yyyy-mm-dd), Mobile, Email, Place of Birth, Father Name" name="search" 
          value={search} onChange={callCommand} onKeyUp={(e) => {if (e.key === "Enter") onSearch();}}/>
          <datalist id="usrlist" >
          { 
            data.map((option) => (
              <option key={option.uniqueKey} value={option.uniqueKey}
                >{option.uniqueValue}</option>
            ))
          }
          </datalist>
          <span class="input-group-text" >
            <button class="navbar-brand m-0 p-0 btn btn-white border-0" onClick={onSearch}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
            </svg>
            </button>
          </span>
          <span class="input-group-text" >
            <Link to="/newclient.html">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
            </svg>
            </Link>
          </span>
        </div>
      </div>

      <div class="d-none d-md-block row m-0 p-0">
      <nav class="navbar navbar-expand-sm border-bottom border-1 border-body p-0">
        <div class="container-fluid ps-2">
          <a class="navbar-brand p-0" href="/home.html">
            <img src="/images/logo.png" alt="Yawin Astro"  class="p-0 logostyle" />
            <span class="ps-2 logotitlestyle">Yawin Astro</span>
          </a>   
        </div>

        <div class="input-group ">
          <input type="input" class="form-control" list="usrlist" id="search" placeholder="Search by Id, Name, DOB(yyyy-mm-dd), Mobile, Email, Birth Place" title="Type few characters of Id, Name, Date of Birth(yyyy-mm-dd), Mobile, Email, Place of Birth, Father Name" name="search" 
          value={search} onChange={callCommand} onKeyUp={(e) => {if (e.key === "Enter") onSearch();}}/>
          <datalist id="usrlist" >
          { 
            data.map((option) => (
              <option key={option.uniqueKey} value={option.uniqueKey}
                >{option.uniqueValue}</option>
            ))
          }
          </datalist>

          <span class="input-group-text" >
            <button class="navbar-brand m-0 p-0 btn btn-white border-0" onClick={onSearch}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
            </svg>
            </button>
          </span>
          <span class="input-group-text" >
            <Link to="/newclient.html">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
            </svg>
            </Link>
          </span>
        </div>

        <div class="w-50"></div>
        <div class="pe-2">
          <Link to="/home.html">
            <img src="/images/home_trans.png" data-bs-toggle="tooltip" data-bs-placement="top" title="Home" alt="Home"  class="p-0 headericonstyle"/>
          </Link>
        </div>
        <div class="pe-2">
          <Link to="/caconfig.html">
            <img src="/images/settings_trans.png" data-bs-toggle="tooltip" data-bs-placement="top" title="Settings" alt="Settings"  class="p-0 headericonstyle"/>
          </Link>
        </div>
        <div class="pe-2">
          <Link to="/profile.html">
            <img src="/images/profile_trans.png" data-bs-toggle="tooltip" data-bs-placement="top" title="Profile" alt="Profile"  class="p-0 headericonstyle" />
          </Link>
        </div>
        <div class="pe-3">
          <button class="navbar-brand p-0 btn btn-white border-0">
            <img src="/images/logout_trans.png" onClick={handleShow} title="Logout" alt="Logout" class="p-0 headericonstyle"/>
          </button>
        </div>
      </nav>

      <Modal centered backdrop="static" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>You tried to Signoff from the applicaition. Do you really want to exit?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleLogout}>Yes</Button>
          <Button variant="primary" onClick={handleClose}>No</Button>
        </Modal.Footer>
      </Modal>

      {showErrorMessage!=="Request failed with status code 403"?<></>:
        <Modal centered backdrop="static" show={showError} onHide={handleLogout}>
          <Modal.Header closeButton>
            <Modal.Title>Login Error</Modal.Title>
          </Modal.Header>
          <Modal.Body>Login Expired. Please Login again</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleLogout}>Login</Button>
          </Modal.Footer>
        </Modal>
      }
      {showErrorMessage!=="Network Error"?<></>:
        <Modal centered backdrop="static" show={showError} onHide={()=>handleHome()}>
          <Modal.Header closeButton>
            <Modal.Title>Network Error</Modal.Title>
          </Modal.Header>
          <Modal.Body>Network Error - Please check internet connection</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={()=>handleHome()}>Ok</Button>
          </Modal.Footer>
        </Modal>
      }

      <Modal centered backdrop="static" show={showSearchAlert} onHide={handleSearchClose}>
        <Modal.Header closeButton>
          <Modal.Title>Search</Modal.Title>
        </Modal.Header>
        <Modal.Body>{searchErrorMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSearchClose}>Ok</Button>
        </Modal.Footer>
      </Modal>

      </div>
    </>
  );
}
